const publicPath = require('@commons/config/publicPath').default;

function getPlatformIcon(size = 384) {
  return `${publicPath}/pwa/manifest/pedidosya/icons/icon-${size}x${size}-5.png`;
}

export default getPlatformIcon;
